var _rect, _rect2, _rect3, _circle, _circle2, _path, _path2, _rect4, _path3, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicBrandingDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 736,
    height: 116,
    viewBox: "0 0 736 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 736,
    height: 116,
    fill: "#3098F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 60,
    width: 412,
    height: 6,
    rx: 3,
    fill: "#D9D9DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 60,
    width: 115,
    height: 6,
    rx: 3,
    fill: "#FFCC00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 63,
    r: 8,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.506,
    cy: 60.5002,
    r: 26.5002,
    fill: "#082C4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.602 66.951V53.9509C105.602 53.4527 106.131 53.1326 106.572 53.3637L118.442 59.5812C118.905 59.8242 118.918 60.4839 118.463 60.7438L106.593 67.5264C106.151 67.7789 105.602 67.4599 105.602 66.951Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5664 54.0498L47.5664 67.0499C47.5664 67.5481 47.0374 67.8682 46.5961 67.637L34.7264 61.4196C34.2625 61.1765 34.2504 60.5168 34.7051 60.257L46.5748 53.4743C47.0166 53.2218 47.5664 53.5409 47.5664 54.0498Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3125,
    y: 68.7822,
    width: 3.31252,
    height: 16.5626,
    rx: 0.5,
    transform: "rotate(180 34.3125 68.7822)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.443 66.9522V53.9521C173.443 53.4539 173.972 53.1338 174.414 53.365L186.283 59.5824C186.747 59.8254 186.759 60.4851 186.305 60.745L174.435 67.5276C173.993 67.7801 173.443 67.4611 173.443 66.9522Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 186.691,
    y: 52.2197,
    width: 3.31252,
    height: 16.5626,
    rx: 0.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicBrandingDesktop);
export default __webpack_public_path__ + "static/media/sonic-branding-desktop.42ef47a9a4c8767e140a43ca7c3df1e8.svg";
export { ForwardRef as ReactComponent };